import React from 'react';

/**
 * Formerly rendered `{NO_CATCHES_TEXT}` inside span (constant defined in `config.ts`).
 * Updated to render empty cell but leaving component in place in case further changes are requested.
*/
const NoActivity = classPrefix => (
  <span className={`${classPrefix}cell__no-activity`}></span>
);

export default NoActivity;
